import script from "./TranslationIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranslationIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./TranslationIndicator.vue?vue&type=style&index=0&id=0b2e6870&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2e6870"]])

export default __exports__